import { render, staticRenderFns } from "./AssociaQuestionariEM.vue?vue&type=template&id=44206286&scoped=true&"
import script from "./AssociaQuestionariEM.vue?vue&type=script&lang=js&"
export * from "./AssociaQuestionariEM.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44206286",
  null
  
)

export default component.exports